<script setup lang="ts">
import type { ActiveFilterChip } from '~/utils/filter/chips'

const openFilter = defineModel('openFilter', { default: false })

const { searchKeyword, totalJournals, sortFilter, selectedLegalArea } = useJournalFilters()

const chips = computed<ActiveFilterChip[]>(() => {
  return selectedLegalArea.value.map((option) => ({
    key: option.value,
    label: option.label,
    remove: () => {
      selectedLegalArea.value = selectedLegalArea.value.filter((o) => o.value !== option.value)
    },
  }))
})
</script>

<template>
  <FilterListHeader
    breakpoint="md"
    v-model:search="searchKeyword"
    v-model:open-filter="openFilter"
    :count="`${totalJournals} treff`"
    search-id="journal-search-compact"
    search-label="Filtrer på tidsskrift"
    search-placeholder="Søk i tidsskrifter"
    :chips="chips"
  >
    <template #actions>
      <FilterSortSelect id="sort-journals" v-model="sortFilter" :options="JOURNAL_SORTING_OPTIONS" />
    </template>
    <JournalsMobileFilters v-model:open-filter="openFilter" />
  </FilterListHeader>
</template>
